import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from 'hooks/useAuth';
// routes
import { PATH_DASHBOARD, PATH_PRIVATE } from 'routes/paths';
// hooks
import useQueryParams from 'hooks/useQueryParams';
// pages
import ResetPassword from 'pages/auth/ResetPassword';


// ----------------------------------------------------------------------
export default function GuestGuard({ children }) {
  const { isAuthenticated, error, directAccess, authorizedIpp, isMustResetPassword } = useAuth();
  const queries = useQueryParams();
  const isBadRequest = (!queries.ipp && !queries.nohosp && !queries.logincode && Object.values(queries).length > 0) || (queries.ipp && queries.nohosp);

  useEffect(() => {
    if (Object.values(queries).length > 0 && error === null) {
      directAccess({ email: queries.logincode, ippValue: queries.ipp, nohosp: queries.nohosp, isBadRequest });
    }
    // eslint-disable-next-line
  }, [queries]);

  if (isMustResetPassword)
    return <ResetPassword />;



  if (isAuthenticated) {
    return <Navigate to={queries?.logincode ? `${PATH_PRIVATE.demandes.list}/${authorizedIpp}` : PATH_DASHBOARD.root} />;
  }

  return <>{children}</>;
}
